import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.227 16.021h2.864V9.066L0 5.998v8.796c0 .678.55 1.227 1.227 1.227Z"
      fill="#4285F4"
    />
    <path
      d="M13.91 16.021h2.863c.678 0 1.227-.55 1.227-1.227V5.998l-4.09 3.068v6.955Z"
      fill="#34A853"
    />
    <path
      d="M13.91 3.748v5.318L18 5.998V4.362c0-1.517-1.732-2.383-2.945-1.473l-1.146.86Z"
      fill="#FBBC04"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.09 9.066V3.748L9 7.43l4.91-3.682v5.318L9 12.748 4.09 9.066Z"
      fill="#EA4335"
    />
    <path
      d="M0 4.362v1.636l4.09 3.068V3.748L2.946 2.89C1.731 1.98 0 2.845 0 4.362Z"
      fill="#C5221F"
    />
  </svg>
);
export default SvgLogoGmail;
